import { ToroLocationDetailed } from "../../../api/models/toro-location-detailed.model";
import { ToroAccountDetailed } from "../../../api/models/toro-account-detailed.model";
import { ToroLocation } from "../../../api/models/toro-location.model";
import { createAction, props } from "@ngrx/store";
import { Color } from "../../../api/models/color.model";
import { ConnectedDevice } from "./../../../api/models/connected-device.model";
import { Update } from "@ngrx/entity";

export const loadLocationsForAccount = createAction(
    "[Locations] Load Locations for Account via service",
    props<{ account: ToroAccountDetailed; useCache: boolean }>()
);

export const locationsForAccountLoaded = createAction(
    "[Locations] Locations Loaded Successfully",
    props<{ locations: ToroLocation[] }>()
);

export const selectLocation = createAction(
    "[Locations] Select Location",
    props<{ currentLocation: ToroLocation }>()
);

export const setLocation = createAction(
    "[Locations] Select Location Success",
    props<{ currentLocation: ToroLocation }>()
);

export const setConnectedDeviceForCurrentLocation = createAction(
    "[Locations] Set ConnectedDevice for CurrentLocation",
    props<{ connectedDevice: ConnectedDevice }>()
);

export const unsetLocation = createAction(
    "[Locations] Unset selected Location Success"
);

export const selectLocationDetail = createAction(
    "[Locations] Get Location Detail via service",
    props<{ locationDetail: ToroLocationDetailed }>()
);

export const selectLocationDetailSuccess = createAction(
    "[Locations] Get Location Detail via service Success",
    props<{ locationDetail: ToroLocationDetailed }>()
);

export const setDefaultThemeForScene = createAction(
    "[Locations] Set Default Theme for Location",
    props<{ locationId: number }>()
);

export const setDefaultThemeSuccess = createAction(
    "[Locations] Set Default Theme for Location Success",
    props<{ isDefualtThemeSet: boolean }>()
);

export const createLocation = createAction(
    "[Locations] Create Location via service",
    props<{ accountId: number; location: ToroLocation }>()
);

export const createLocationSuccess = createAction(
    "[Locations] Create Location Success",
    props<{ location: ToroLocation }>()
);

export const createGateway = createAction(
    "[Locations] Create Gateway for Location via service",
    props<{
        accountId: number;
        locationId: number;
        gatewayName: string;
        gatewaySecurityKey: string;
    }>()
);

export const createGatewaySuccess = createAction(
    "[Locations] Create Gateway for Location via service Success",
    props<{ locationId: number }>()
);

export const deleteLocation = createAction(
    "[Locations] Delete Location via service",
    props<{ locationId: number }>()
);

export const deleteLocationSuccess = createAction(
    "[Locations] Delete Location Success",
    props<{ locationId: number }>()
);

export const updateLocation = createAction(
    "[Locations] Update Location via service",
    props<{ location: ToroLocation }>()
);

export const updateLocationSuccess = createAction(
    "[Locations] Update Location via service Success",
    props<{ update: Update<ToroLocation> }>()
);

export const startPollingForNotification = createAction(
    "[Locations] Notification Polling started for Location via service",
    props<{ accountId: number }>()
);

export const startPollingForNotificationSuccess = createAction(
    "[Locations] Notification Polling started for Location via service success",
    props<{notifications: any[] }>()
);

export const startPollingForNotificationFailure = createAction(
    "[Locations] Notification Polling started for Location via service failure",
    props<{error: any }>()
);

export const stopPollingForNotification = createAction(
    "[Locations] Notification Polling stopped for Location via service"
);



export const toroLocationActionTypes = {
    loadLocationsForAccount,
    locationsForAccountLoaded,
    createLocation,
    createLocationSuccess,
    createGateway,
    createGatewaySuccess,
    deleteLocation,
    deleteLocationSuccess,
    updateLocation,
    updateLocationSuccess,
    selectLocation,
    selectLocationDetail,
    selectLocationDetailSuccess,
    setLocation,
    setConnectedDeviceForCurrentLocation,
    unsetLocation,
    setDefaultThemeForScene,
    setDefaultThemeSuccess,
    startPollingForNotification,
    stopPollingForNotification,
    startPollingForNotificationSuccess,
    startPollingForNotificationFailure
};
